import request from "./request";

const api = {
  getUserServerRecordList: "user_server_record/getUserServerRecordList",
};
export default {
  getUserServerRecordList(parameter) {
    return request({
      url: api.getUserServerRecordList,
      method: "POST",
      data: parameter,
    });
  },
};
